'use client';

import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

const RootRedirect = () => {
  const { push } = useRouter();

  useEffect(() => {
    push('/rooms');
  }, []);
};

export default RootRedirect;
